import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const SmartphoneCharging: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['rect', { width: '14', height: '20', x: '5', y: '2', rx: '2', ry: '2' }],
    ['path', { d: 'M12.667 8 10 12h4l-2.667 4' }],
  ],
];

export default SmartphoneCharging;
